import { useExpenseQuery } from "web_myplann/Api/Finances/useExpenseQuery";
import { useIncomeQuery } from "web_myplann/Api/Finances/useIncomeQuery";

export const useFinancialBalance = () => {
	const { data: expenses, isLoading: isExpensesLoading } = useExpenseQuery();
	const { data: income, isLoading: isIncomeLoading } = useIncomeQuery();

	const incomeSum =
		income?.data?.reduce((acc, curr) => acc + (curr?.amount ?? 0), 0) ?? 0;
	const expenseSum =
		expenses?.data?.reduce(
			(acc, curr) => acc + (curr?.monthlyPayment ?? 0),
			0,
		) ?? 0;

	return {
		isLoading: isExpensesLoading || isIncomeLoading,
		hasNoData: !Array.isArray(expenses?.data) && !Array.isArray(income?.data),
		hasNoBalance: income?.data?.length === 0 && expenses?.data?.length === 0,
		incomeSum,
		expenseSum,
		balance: incomeSum - expenseSum,
	};
};
